<ng-container *ngIf="configuredField">
  <div class="form-field-configurator-settings py-2">
    <irembogov-button-group
      class="w-100"
      [itemList]="configurationTabs"
      [selectedItem]="selectedConfigurationTab"
      (itemChange)="selectedConfigurationTab = $event"
      [fullWidth]="true"
      [iconAboveLabel]="true"
      uiStyle="flat-tabs"
      theme="irembo-blue-theme"></irembogov-button-group>

    <div class="p-3">
      <ng-container
        *ngIf="
          selectedConfigurationTab === EConfigurationTabTemplateKeys.Settings
        ">
        <irembogov-irembo-section-message
          *ngIf="settingsFormErrorFields.length > 0"
          type="error"
          [title]="settingsFormErrorFields.length + ' error(s) found'"
          message="Please correct the following errors in the form below:"
          extraMessage="
            {{
            '&lt;ul&gt; &lt;li&gt;' +
              settingsFormErrorFields.join('&lt;/li &gt; &lt;li &gt;') +
              '&lt;/li&gt; &lt;/ul&gt;'
          }}
          "
          [extraMessageAsHtml]="true"
          id="serviceConfigurationErrorMessage"></irembogov-irembo-section-message>
        <form [formGroup]="settingsForm" class="field-config-settings-form">
          <formly-form
            [form]="settingsForm"
            [options]="formlyFormOptions"
            [model]="settingsModel"
            [fields]="
              fieldConfigurationConfig.settings.formlyForm
            "></formly-form>

          <div class="pb-4">
            <div class="small text-muted" *ngIf="autoSaveInProgress">
              <div
                class="spinner-border spinner-border-sm mr-1"
                role="status"
                style="width: 0.8rem; height: 0.8rem"></div>
              <span>Autosaving...</span>
            </div>
            <div
              class="small text-muted"
              *ngIf="lastAutoSaved && !autoSaveInProgress">
              <span>Last saved: {{ lastAutoSaved | date : 'medium' }}</span>
            </div>
            <button
              class="btn btn-primary bt-sm mt-1"
              type="button"
              (click)="saveFieldConfigurationSettings()">
              Save
            </button>
          </div>
        </form>
      </ng-container>

      <ng-container
        *ngIf="
          selectedConfigurationTab === EConfigurationTabTemplateKeys.Validation
        ">
        <form [formGroup]="validationForm" class="field-config-validation-form">
          <formly-form
            [form]="validationForm"
            [options]="formlyFormOptions"
            [model]="validationModel"
            [fields]="
              fieldConfigurationConfig.validations?.formlyForm || []
            "></formly-form>

          <div class="pb-4">
            <div class="small text-muted" *ngIf="autoSaveInProgress">
              <div
                class="spinner-border spinner-border-sm mr-1"
                role="status"
                style="width: 0.8rem; height: 0.8rem"></div>
              <span>Autosaving...</span>
            </div>
            <div
              class="small text-muted"
              *ngIf="lastAutoSaved && !autoSaveInProgress">
              <span>Last saved: {{ lastAutoSaved | date : 'medium' }}</span>
            </div>
            <button
              [disabled]="validationForm.invalid"
              class="btn btn-primary bt-sm mt-1"
              type="button"
              (click)="saveFieldConfigurationValidation()">
              Save
            </button>
          </div>
        </form>
      </ng-container>

      <ng-container
        *ngIf="
          selectedConfigurationTab === EConfigurationTabTemplateKeys.Display
        ">
        <form [formGroup]="displayForm" class="field-config-display-form">
          <formly-form
            [form]="displayForm"
            [options]="formlyFormOptions"
            [model]="displayModel"
            [fields]="
              fieldConfigurationConfig.display?.formlyForm || []
            "></formly-form>

          <div class="pb-4">
            <div class="small text-muted" *ngIf="autoSaveInProgress">
              <div
                class="spinner-border spinner-border-sm mr-1"
                role="status"
                style="width: 0.8rem; height: 0.8rem"></div>
              <span>Autosaving...</span>
            </div>
            <div
              class="small text-muted"
              *ngIf="lastAutoSaved && !autoSaveInProgress">
              <span>Last saved: {{ lastAutoSaved | date : 'medium' }}</span>
            </div>
            <button
              [disabled]="displayForm.invalid"
              class="btn btn-primary bt-sm mt-1"
              type="button"
              (click)="saveFieldConfigurationDisplay()">
              Save
            </button>
          </div>
        </form>
      </ng-container>
    </div>
  </div>
</ng-container>
